export const isItemPath = (path: string) => {
  const splitted = path.split('/');
  const datasetIndex = splitted.indexOf('dataset');

  if (datasetIndex === -1) return false;

  const filtered = splitted.slice(datasetIndex);

  if (filtered.length === 4 && filtered[filtered.length - 2] === 'detail') {
    return true;
  }

  if (filtered.length === 4 && filtered[filtered.length - 2] === 'item') {
    return true;
  }

  if (
    filtered.length === 6 &&
    filtered[filtered.length - 2] === 'subset' &&
    filtered[filtered.length - 4] === 'item'
  ) {
    return true;
  }

  if (
    filtered.length === 6 &&
    filtered[filtered.length - 2] === 'subset' &&
    filtered[filtered.length - 4] === 'detail'
  ) {
    return true;
  }

  return false;
};
